import React from "react";
import logger from "logger";
import { StringValue } from "../Tasklets/StringValue";

export default function(props) {
  const { task, showOwner = false, showUser = false } = props;
  logger.log(showOwner, showUser);
  return (
    <>
      {showOwner && (
        <StringValue
          label={"Owner"}
          value={`${task.taskstatusdetail.accountdetail.account.alias}(${
            task.taskstatusdetail.accountdetail.server
          })`}
        />
      )}
      {showUser &&
        task.taskstatusdetail.accountdetail.authorizedsendingusername && (
          <div>
            <StringValue
              label={"User"}
              value={
                task.taskstatusdetail.accountdetail.authorizedsendingusername
              }
            />
            <StringValue
              label={"Email"}
              value={task.taskstatusdetail.accountdetail.account.email}
            />
          </div>
        )}
    </>
  );
}
